<loading *ngIf="isLoading"></loading>
<div class="account-center" *ngIf="!isLoading">
  <ng-container *ngIf="showPolicyDetails">
    <policy-details></policy-details>
  </ng-container>
  <div class="account-center__partial">
    <partial-include [componentData]="{ page: pageToInclude }"></partial-include>
  </div>
</div>
